import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/LegalNotice.css';

const LegalNotice = () => {
  return (
    <div className="legal-notice-page">
      <div className="container">
        <div className="legal-notice-header">
          <h1>Mentions Légales</h1>
          <Link to="/" className="back-link">← Retour à l'accueil</Link>
        </div>

        <div className="legal-notice-content">
          <section className="legal-section">
            <h2>Informations légales</h2>
            <p>
              <strong>Raison sociale :</strong> FDP AUTOMOBILES<br />
              <strong>Forme juridique :</strong> EURL<br />
              <strong>Siège social :</strong> 72 Avenue Gustave Eiffel, 37390 Notre Dame D'Oé<br />
              <strong>Téléphone :</strong> 02 47 54 01 86<br />
              <strong>Email :</strong> fdp-automobiles@live.fr<br />
              <strong>SIRET :</strong> 791 552 060 00018<br />
              <strong>N° TVA Intracommunautaire :</strong> FR 657 915 520 60
            </p>
          </section>

          <section className="legal-section">
            <h2>Directeur de la publication</h2>
            <p>
              Le directeur de la publication du site est <strong>M. Christophe WACHEUX</strong>, en sa qualité de gérant de la société FDP AUTOMOBILES.
            </p>
            <p>
              Le site est conçu, développé et maintenu par <strong>Steven COUBLANT</strong>, responsable technique et gestionnaire du contenu.
            </p>
          </section>

          <section className="legal-section">
            <h2>Hébergement</h2>
            <p>
            Ce site est hébergé par : <strong>Amazon Web Services (AWS)</strong><br />
            <strong>Service :</strong> Amazon EC2 (Elastic Compute Cloud)<br />
            <strong>Site web :</strong> https://aws.amazon.com/fr/ec2/<br />
            <strong>Adresse :</strong> Amazon Web Services EMEA SARL, 38 Avenue John F. Kennedy, L-1855 Luxembourg
            </p>
          </section>

          <section className="legal-section">
            <h2>Conception et maintenance</h2>
            <p>
              <strong>Développeur & Gestionnaire :</strong> Steven COUBLANT<br />
              <strong>Contact :</strong>steven.coublant@stech-solutions.net<br />
              <strong>Rôle :</strong> Conception, développement, déploiement et maintenance du site web
            </p>
          </section>

          <section className="legal-section">
            <h2>Protection des données personnelles</h2>
            <p>
              Le site FDP AUTOMOBILES ne collecte aucune donnée personnelle de ses visiteurs.
              Nous n'utilisons pas de cookies de traçage ni de systèmes d'analyse de comportement.
              Les seules interactions possibles se font via les coordonnées de contact affichées
              sur le site (téléphone et email).
            </p>
          </section>

          <section className="legal-section">
            <h2>Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu de ce site (textes, images, vidéos, etc.) est protégé 
              par les lois relatives à la propriété intellectuelle. Toute reproduction ou 
              représentation, intégrale ou partielle, par quelque procédé que ce soit, 
              faite sans le consentement de FDP AUTOMOBILES, est illicite.
            </p>
          </section>

          <section className="legal-section">
            <h2>Cookies</h2>
            <p>
              Ce site n'utilise aucun cookie de traçage ou de collecte de données.
            </p>
          </section>

          <section className="legal-section">
            <h2>Loi applicable</h2>
            <p>
              Les présentes mentions légales sont soumises au droit français. En cas de 
              litige, les tribunaux français seront seuls compétents.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default LegalNotice;
